import axios from "axios";

const apiServerUrl =
  process.env.REACT_APP_API_BASE_URL ||
  "https://mhisapi-wyh4dbquta-ew.a.run.app/api/";

console.log(`api server url: ${apiServerUrl}`);

export default axios.create({
  baseURL: apiServerUrl,
  withCredentials: true,
  headers: {
    "Content-type": "application/json",
  },
});
